import { useEffect, useRef, useState } from "react";
import { multipartPostCall, simpleGetCallWithErrorResponse, simpleGetCall, PostCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import AddCompany from "./AddCompany";
import { Form } from "react-bootstrap";
import {
    updateFormField,
} from "./Slices/formSlice";
import { toastMsg } from "../component/toast";
import CustomButton from "../component/button";
import Select from "react-select";
import CustomSelect from "../constant/customselect";
import {
    jobType,
    lungueges,
    travelRequirement,
    workType,
} from "../constant/jobType";
import { useNavigate } from "react-router-dom";
import { handleValidation, objectsAreDifferent, shallowEqual } from "../common";
import { optionsSalary } from "../constant/optionSalary";
import { educationOptions } from "../constant/educationOpt";
import MessageBox from "../component/MessageBox";


const JobInformation = ({ isBack, setSearchParams }) => {

    const [isPdfUpload, setIsPdfUpload] = useState(false);
    const [isFormFilled, setisFormFilled] = useState(false)

    const [isSkipQuiz, setIsSkipQuiz] = useState(false)

    const [isDetailsChange, setIsDetailChange] = useState(false)

    const uploadPdf = useRef();

    const [companies, setCompanies] = useState([]);

    const [error, setError] = useState("");
    const [industries, setIndustries] = useState([]);

    const [isLoading, setIsLoading] = useState(false)

    const [isValided, setIsValided] = useState(false)


    const [isAddCompany, setIsAddCompany] = useState(false);

    const [errMsg, setErrMsg] = useState({})

    const navigate = useNavigate()

    const formData = useSelector((state) => state.form);

    const dispatch = useDispatch();


    const handleAddCompamy = () => {
        getCompanies();

        setIsAddCompany(false);
    };

    const getCompanies = () => {
        simpleGetCall(ApiConfig.GET_COMPANY_LIST).then((res) => {
            if (res?.succeded) {
                let companiesList = res?.response?.map((i) => ({
                    value: i?.id,
                    label: i?.companyName,
                    data: i
                }));

                companiesList[0] = {
                    value: "",
                    label: "Add Company Name",
                };

                setCompanies(companiesList);
            } else {
                setCompanies([]);
            }
        });
    };

    const getIndustries = () => {
        simpleGetCall(ApiConfig.GET_INDUSTRY_LIST).then((res) => {
            if (res?.response) {
                setIndustries(res?.response);
            }
        });
    };

    const getCompanyDetails = (id) => {
        if (!id) return;
        simpleGetCallWithErrorResponse(ApiConfig.GET_COMPANY_DETAIL + id).then(
            (res) => {
                if (res?.json?.succeded) {
                    let data = res?.json?.response;

                    dispatch(updateFormField({ field: 'companyLogo', value: data?.companyLogo }))
                    dispatch(
                        updateFormField({ field: "companyName", value: data?.companyName })
                    );
                    dispatch(
                        updateFormField({ field: "industry", value: data?.industry })
                    );
                    dispatch(
                        updateFormField({ field: "website", value: data?.companyWebsite })
                    );
                    dispatch(
                        updateFormField({
                            field: "companyDescription",
                            value: data?.aboutCompany,
                        })
                    );
                    dispatch(
                        updateFormField({ field: "companyType", value: data?.companyType })
                    );
                    dispatch(
                        updateFormField({ field: "companySize", value: data?.companySize })
                    );
                    dispatch(
                        updateFormField({ field: "location", value: data?.headQuarters })
                    );
                } else {
                    toastMsg("error", "Something went wrong in add company ! try again");
                }
            }
        );
    };

    const handleUpload = (file) => {
        const formData = new FormData();

        formData.append("file", file);

        setIsPdfUpload(true);

        multipartPostCall(ApiConfig.UPLOAD_JD, formData).then((res) => {
            if (res?.status == 200) {
                let data = res?.job_description?.job_details;

                dispatch(
                    updateFormField({ field: "jobTitle", value: data?.job_title })
                );
                dispatch(
                    updateFormField({
                        field: "noOfPositions",
                        value: data?.no_of_positions,
                    })
                );
                dispatch(
                    updateFormField({ field: "department", value: data?.job_department })
                );
                dispatch(
                    updateFormField({
                        field: "anyLanguageOtherThanEnglish",
                        value: data?.job_language,
                    })
                );
                dispatch(updateFormField({ field: "jobType", value: data?.job_type }));
                dispatch(
                    updateFormField({
                        field: "workPlaceType",
                        value: data?.workplace_type,
                    })
                );
                dispatch(
                    updateFormField({
                        field: "experience",
                        value: data?.experience_required,
                    })
                );
                dispatch(
                    updateFormField({
                        field: "minEducationQualification",
                        value: data?.job_qualifications || "",
                    })
                );
                dispatch(
                    updateFormField({
                        field: "travelRequirement",
                        value: data?.travel_requirements,
                    })
                );
                dispatch(
                    updateFormField({
                        field: "descriptionAboutJob",
                        value: data?.job_description,
                    })
                );
                dispatch(
                    updateFormField({
                        field: "locationJobDetails",
                        value: data?.job_location,
                    })
                );
                dispatch(updateFormField({ field: "", value: "" }));
                toastMsg("success", res?.message);

                setIsPdfUpload(false);
                setError("");
            } else {
                toastMsg("error", res?.message);
            }
        });
    };

    function normalizeToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim() !== "") return [value];
        return []; // handle undefined, null, empty string
    }

    const checkFormFilled = () => {
        const {
            jobTitle,


            noOfPositions,
            department,
            locationJobDetails,
            anyLanguageOtherThanEnglish,
            jobType,
            workPlaceType,
            minEducationQualification,
            travelRequirement,
            descriptionAboutJob,
            companyId,
        } = formData;

        return !companyId ||
            !jobTitle ||
            // !jobDetails ||
            // !keyFocus ||
            !department ||
            !jobType ||
            !workPlaceType ||
            !travelRequirement ||
            !descriptionAboutJob
    }

    const handleSubmit = (isSkip = false) => {



        if (
            checkFormFilled()
        ) {
            setIsValided(true)
            toastMsg('error', 'Please Fill All Fields')
        } else {
            setIsValided(false)

            if (isSkip) {
                setIsSkipQuiz(true)
            } else {
                setIsLoading(true)

            }

            if (!formData?.noOfPositions) {

                dispatch(updateFormField({ field: 'noOfPositions', value: 1 }))
            }


            let payload = {
                code: formData?.tempJobCode,
                jobInfoId: formData?.jobDescriptionId,
                "company": {
                    "id": formData?.comapnyDetailsId,
                    "companyName": formData?.companyName,
                    "headQuarters": formData?.location,
                    "aboutCompany": formData?.companyDescription,
                    "industry": formData?.industry,
                    "companyWebsite": formData?.website,
                    "companyType": formData?.companyType,
                    "companySize": formData?.companySize,
                    companyLogo: formData?.companyLogo
                },
                jobInformation: {
                    id: formData?.jobDescriptionId || 0,
                    jobTitle: formData?.jobTitle,
                    noOfPositions: formData?.noOfPositions || 1,
                    department: formData.department,
                    location: formData?.locationJobDetails,
                    // languages: formData.finalJobDetails?.language,
                    languages: normalizeToArray(formData?.anyLanguageOtherThanEnglish),
                    jobType: formData?.jobType,
                    workplaceType: formData?.workPlaceType,
                    descriptionAboutJob: formData.descriptionAboutJob,
                    experienceReq: formData?.experience,
                    salaryRange: formData?.salary,
                    minimumEducationalQualification: formData?.minEducationQualification,
                    employmentType: formData.employmentType,
                    // industry : formData.industry,
                    industry: normalizeToArray(formData.industry),
                    skillsets: formData.skillsRequiredForJob,
                    educationAreas: normalizeToArray(formData?.educationArea),
                    role: formData.finalJobDetails?.job_title,
                    requiredBy: "2025-06-10T00:00:00Z",
                    travel_requirements: formData.travelRequirement,
                },

                "position": formData?.jobTitle,
                step: 0

            }
            PostCallWithErrorResponse(ApiConfig.POST_TEMP_JOB_CODE, payload).then((res) => {

                if (res?.json?.succeded) {
                    dispatch(updateFormField({ field: 'tempJobCode', value: res?.json?.response?.jobcode }))
                    dispatch(updateFormField({ field: 'tempJobCodeResp', value: res?.json?.response }))
                    dispatch(updateFormField({ field: 'jobDescriptionId', value: res?.json?.response?.jdJobInformationId }))

                    if (isSkip) {

                        dispatch(updateFormField({ field: 'isSkippedQuiz', value: true }))

                        dispatch(updateFormField({ field: 'finalSelectedJobDescription', value: formData.descriptionAboutJob }))

                        navigate('Topics')
                    } else {
                        dispatch(updateFormField({ field: 'step', value: 1 }))

                        navigate('/jobDescription?isBack=' + isBack)
                    }


                }

                setIsLoading(false)

            })
        }

    }

    useEffect(() => {

        getCompanies()
        getIndustries()

    }, [])

    useEffect(() => {

        setisFormFilled(checkFormFilled)

    }, [formData])

    const handleChange = (e) => {
        // setFormData({ ...formData, [e.target.name]: e.target.value });
        dispatch(updateFormField({ field: e.target.name, value: e.target.value }));
    };

    const resetData = () => {

        let data = JSON.parse(sessionStorage.getItem('prev_selected_jobdetails'))

        console.log(data);


        dispatch(
            updateFormField({ field: "jobTitle", value: data?.job_title })
        );
        dispatch(
            updateFormField({
                field: "noOfPositions",
                value: data?.no_of_positions,
            })
        );
        dispatch(
            updateFormField({ field: "department", value: data?.job_department })
        );
        dispatch(
            updateFormField({
                field: "anyLanguageOtherThanEnglish",
                value: data?.job_language,
            })
        );
        dispatch(updateFormField({ field: "jobType", value: data?.job_type }));
        dispatch(
            updateFormField({
                field: "workPlaceType",
                value: data?.workplace_type,
            })
        );
        dispatch(
            updateFormField({
                field: "experience",
                value: data?.experience_required,
            })
        );
        dispatch(
            updateFormField({
                field: "minEducationQualification",
                value: data?.minEducationQualification,
            })
        );
        dispatch(
            updateFormField({
                field: "travelRequirement",
                value: data?.travel_requirements,
            })
        );
        dispatch(
            updateFormField({
                field: "descriptionAboutJob",
                value: data?.job_description,
            })
        );
        dispatch(
            updateFormField({
                field: "locationJobDetails",
                value: data?.job_location,
            })
        );

        dispatch(
            updateFormField({
                field: "salary",
                value: data?.salary_range,
            })
        );



        dispatch(
            updateFormField({
                field: "minEducationQualification",
                value: data?.job_qualifications,
            })
        );


        setIsDetailChange(false)

    }

    return (
        <>
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h4 className="jb-3 mt-4">Job Details</h4>
            </div> */}
            <form className="space-y-5 max-w-2xl job-description-form">
                <div className="">
                    <div className="d-flex justify-content-center margin-btn-input ">
                        <input
                            type="file"
                            ref={uploadPdf}
                            className="d-none"
                            accept=".pdf,.html"
                            onChange={(e) => {
                                handleUpload(e.target.files[0]);
                            }}
                        />
                        <CustomButton
                            isLoading={isPdfUpload}
                            title="Have A Job Description To Upload Instead ? Upload And Continue"
                            handleClick={() => uploadPdf.current.click()}
                            buttonType="secondary"
                        />
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Company Name <span className="fw-bolder astclr h6">*</span>
                        </label>
                        <div className="w-60">
                            <CustomSelect
                                isMulti={false}
                                options={companies}
                                labelKey={'label'}
                                valKey={'value'}

                                handleChange={(e, data) => {
                                    console.log(data);
                                    dispatch(
                                        updateFormField({
                                            field: "companyId",
                                            value: e,
                                        })
                                    );
                                    console.log(e);
                                    getCompanyDetails(e);
                                }}

                                value={
                                    formData?.companyId

                                }

                                size="medium"
                                isClearaAble={false}
                            />
                            {/* <Select
                                isMulti={false}
                                options={companies}
                                value={
                                    companies.find(
                                        (option) => option.value === formData?.companyId
                                    ) || null
                                }
                                onChange={(e) => {
                                    dispatch(
                                        updateFormField({
                                            field: "companyId",
                                            value: e.value,
                                        })
                                    );
                                    console.log(e);
                                    getCompanyDetails(e.value);
                                }}
                                classNamePrefix="select"
                                placeholder="Company Name"
                                className="w-full  text-black jb-in-2"
                            /> */}
                            {
                                isValided && !formData?.companyId && <span className="errormSg">Please Select Company</span>
                            }

                        </div>
                        <div style={{ marginLeft: "-30px" }}>
                            <CustomButton
                                isLoading={false}
                                handleClick={() => setIsAddCompany(true)}
                                title={formData?.companyId ? "Edit" : "Add"}
                                buttonType={"buutonTertiory"}
                            />
                        </div>
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Job Title <span className="fw-bolder astclr h6">*</span>
                        </label>
                        <div style={{ width: '60%' }}>
                            <input
                                style={{ height: "38px" }}
                                name="jobTitle"
                                value={formData.jobTitle}
                                onChange={handleChange}
                                className="w-full rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                            />
                            {
                                isValided && !formData?.jobTitle && <span className="errormSg">Please Enter Job Title</span>
                            }

                        </div>
                    </div>

                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            No. Of Positions
                        </label>
                        <div style={{ width: '60%' }}>
                            <input
                                style={{ height: "38px" }}
                                name="noOfPositions"
                                type="number"
                                value={formData.noOfPositions}
                                onChange={handleChange}
                                className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                            />

                        </div>
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Department <span className="fw-bolder astclr h6">*</span>
                        </label>
                        <div style={{ width: "60%" }}>
                            <div>
                                <input
                                    name="department"
                                    type="text"
                                    value={formData.department}
                                    onChange={handleChange}
                                    className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                                    style={{ height: "38px" }}
                                />

                                {
                                    isValided && !formData?.department && <span className="errormSg">Please Select Department</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Location
                        </label>
                        <div style={{ width: '60%' }}>
                            <input
                                name="locationJobDetails"
                                type="text"
                                value={formData.locationJobDetails}
                                onChange={handleChange}
                                className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                                style={{ height: "38px" }}
                            />

                        </div>
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Experience Required
                        </label>
                        <input
                            name="experience"
                            placeholder="Type Here (eg. 1-3 Years)"
                            value={formData.experience}
                            onChange={handleChange}
                            className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                            style={{ width: "60%", height: "38px" }}
                        />
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Salary
                        </label>
                        <input
                            name="salary"
                            placeholder="Type Here Salary "
                            value={formData.salary}
                            onChange={handleChange}
                            className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                            style={{ width: "60%", height: "38px" }}
                        />

                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Education Area
                        </label>
                        <input
                            name="educationArea"
                            value={formData.educationArea}
                            onChange={handleChange}
                            className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                            style={{ width: "60%", height: "38px" }}
                        />

                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Minimum Qualifications
                        </label>
                        <div className="w-60">
                            <Form.Select aria-label="Default select example"
                                name="minEducationQualification"
                                value={formData.minEducationQualification}
                                onChange={handleChange}
                                className="font-size-base"

                            >
                                <option value={""} className="font-size-base">Select Minimum Qualifications</option>
                                {
                                    educationOptions?.map((edu, index) => {
                                        return <option value={edu?.value} key={index} className="font-size-base">{edu?.label}</option>
                                    })
                                }
                            </Form.Select>
                        </div>
                    </div>

                    <div className="flex  gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Brief Description  <span className="fw-bolder astclr h6">*</span>
                        </label>
                        <div style={{ width: '60%' }}>
                            <textarea
                                name="descriptionAboutJob"
                                value={formData.descriptionAboutJob}
                                rows={4}
                                onChange={handleChange}
                                className="w-full  rounded-md bg-gray-100 border border-grey text-black jb-in-1 "

                            />
                            {
                                isValided && !formData?.descriptionAboutJob && <span className="errormSg">Please Enter Job Description</span>
                            }
                        </div>
                    </div>

                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Languages
                        </label>
                        <div style={{ width: '60%' }}>
                            <input
                                name="anyLanguageOtherThanEnglish"
                                placeholder="Other Than English (eg. Hindi,Marathi,Tamil)"
                                type="text"
                                value={formData.anyLanguageOtherThanEnglish}
                                onChange={handleChange}
                                className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                                style={{ height: "38px" }}
                            />

                        </div>
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input " >
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Travel Requirement <span className="fw-bolder astclr h6">*</span>
                        </label>
                        <div style={{ width: '60%' }}>
                            <Form.Select aria-label="Default select example"
                                className="font-size-base"
                                value={formData.travelRequirement}
                                onChange={(e) => dispatch(updateFormField({ field: 'travelRequirement', value: e.target.value }))}

                            >
                                <option value={""} className="font-size-base">Select Travel Requirement</option>
                                {
                                    travelRequirement?.map((travel, index) => {
                                        return <option value={travel?.value} key={index} className="font-size-base">{travel?.label}</option>
                                    })
                                }
                            </Form.Select>

                            {
                                isValided && !formData?.travelRequirement && <span className="errormSg">Please Select Travel Requirment</span>
                            }
                        </div>
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Job Type <span className="fw-bolder astclr h6">*</span>
                        </label>
                        <div style={{ width: '60%' }}>


                            <Form.Select aria-label="Default select example"
                                className="font-size-base"
                                value={formData.jobType}
                                onChange={(e) => dispatch(updateFormField({ field: 'jobType', value: e.target.value }))}

                            >
                                <option value={""} className="font-size-base">Select Job Type</option>
                                {
                                    jobType?.map((type, index) => {
                                        return <option value={type?.value} key={index} className="font-size-base">{type?.label}</option>
                                    })
                                }
                            </Form.Select>

                            {
                                isValided && !formData?.jobType && <span className="errormSg">Please Select Job Type</span>
                            }
                        </div>
                    </div>
                    <div className="flex align-items-center gap-5 margin-btn-input ">
                        <label className="w-10 text-right pr-4 jb-4-- form-label job_size" style={{ width: "17%" }}>
                            Workplace Type <span className="fw-bolder astclr h6">*</span>
                        </label>
                        <div>
                            <div className="d-flex gap-3">
                                {workType?.map((type) => {
                                    return (
                                        <label className="radio-label gap-1">
                                            <input
                                                type="radio"
                                                id="savedQuiz"
                                                name="saved_quiz"
                                                Placeholder="short"
                                                checked={formData.workPlaceType === type}
                                                onChange={() => {
                                                    dispatch(
                                                        updateFormField({
                                                            field: "workPlaceType",
                                                            value: type,
                                                        })
                                                    );
                                                }}
                                            />
                                            <span for="short" className="active-inac">
                                                {type}
                                            </span>
                                        </label>
                                    );
                                })}
                            </div>
                            {
                                isValided && !formData?.workPlaceType && <span className="errormSg">Please Select Workplace Type</span>
                            }
                        </div>
                    </div>







                </div>
                <div>
                    <div
                        className="d-flex w-100 mt-4"
                        style={{
                            justifyContent: "end",
                            gap: "10px",
                        }}
                    >
                        {/* <CustomButton
                            type="button"
                            isDisabled={isFormFilled}
                            isLoading={isSkipQuiz}
                            title="Skip To Quiz"
                            buttonType="secondary"
                            handleClick={() => {
                                handleSubmit(true)
                            }}
                        /> */}

                        <CustomButton
                            isDisabled={isSkipQuiz}
                            isLoading={isLoading}
                            title="Save And Proceed"
                            handleClick={() => {

                                if (isBack == 'true') {



                                    let prev_jobDetails = JSON.parse(sessionStorage.getItem('prev_selected_jobdetails'))


                                    const company_details = {
                                        company_name: formData.companyName,
                                        industry: formData.industry,
                                        company_size: formData.companySize,
                                        location: formData.location,
                                        company_type: formData.companyType,
                                        company_description: formData.companyDescription,
                                        company_website: formData.website,
                                    };
                                    const job_details = {
                                        job_title: formData.jobTitle,
                                        no_of_positions: formData.noOfPositions,
                                        job_department: formData.department,
                                        job_location: formData.locationJobDetails,
                                        job_language: formData.anyLanguageOtherThanEnglish,
                                        job_type: formData.jobType,
                                        workplace_type: formData.workPlaceType,
                                        job_description: formData.descriptionAboutJob,
                                        experience_required: formData.experience,
                                        salary_range: formData.salary,
                                        job_qualifications: formData.minEducationQualification,
                                        travel_requirements: formData.travelRequirement,
                                        educational_area: formData.educationArea || '',
                                    }

                                    console.log("company_details", job_details, prev_jobDetails);

                                    let hasChanged = prev_jobDetails ? objectsAreDifferent(job_details, prev_jobDetails) : false
                                    if (hasChanged) {
                                        setIsDetailChange(true)
                                    } else {
                                        handleSubmit()
                                    }


                                    // console.log(jobInformation, prev_jobDetails);



                                    // shallowEqual()

                                    return
                                }

                                handleSubmit()
                            }}
                        />
                    </div>
                </div>
            </form >

            {error && (
                <div className="d-flex justify-content-end">
                    <div
                        className="bg-red-100 text-red-700 p-3 rounded mt-4 jb-sub w-100"
                    >
                        {error}
                    </div>
                </div>
            )
            }
            <Modal
                show={isAddCompany}
                centered
                onHide={() => setIsAddCompany(false)}
                size="lg"
                dialogClassName="modal-h-650"
            >
                <Modal.Header closeButton className="custom-close-btn">
                    <h6 className="mb-0 mt-1">
                        {formData?.companyId ? "Update" : "Add"} Company Details
                    </h6>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <AddCompany
                            isHandle={true}
                            handleSubmitClose={() => handleAddCompamy()}
                            id={formData?.companyId}
                        />
                    </div>
                </Modal.Body>
            </Modal>
            <MessageBox
                isOpen={isDetailsChange}
                closeOnOutClick={false}
            >
                <div className="text-center interRegular p-2">
                    You have made changes , this will over write your earlier work , do you want to apply these changes
                </div>
                <div className="d-flex gap-2 justify-content-center mt-2">
                    <CustomButton title="No" buttonType="secondary" handleClick={resetData} />
                    <CustomButton title="Yes" handleClick={() => handleSubmit()} />
                </div>
            </MessageBox>

        </>
    )

}

export default JobInformation